import React from "react";
import Agiletesting1 from "../components/Agiletesting/Agiletesting1";
import Agiletesting2 from "../components/Agiletesting/Agiletesting2";
import Agiletesting3 from "../components/Agiletesting/Agiletesting3";

const Agiletesting = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Agiletesting1 />
      <Agiletesting2 />
      <Agiletesting3 />
    </div>
  );
};

export default Agiletesting;
